"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const classnames_1 = __importDefault(require("classnames"));
const MyShortInfo_1 = __importDefault(require("../components/MyShortInfo/MyShortInfo"));
const appSlice_1 = require("../store/slices/appSlice");
const Logo_1 = __importDefault(require("../components/Logo"));
const translations_1 = require("../helpers/translations");
const store_1 = require("../store/store");
const Sidebar = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { pages, sidebarOpen } = (0, store_1.useAppSelector)((state) => state.app);
    const { showWebsiteLinkInSidebar, dividerAboveLogOutInMeny } = (0, store_1.useAppSelector)((state) => state.app.appSettings || { showWebsiteLinkInSidebar: false, dividerAboveLogOutInMeny: false });
    const region = (0, store_1.useAppSelector)((state) => { var _a, _b; return (_b = (_a = state.app.appSettings) === null || _a === void 0 ? void 0 : _a.region) !== null && _b !== void 0 ? _b : undefined; });
    const [isMobile, setIsMobile] = (0, react_1.useState)(window.innerWidth < 992);
    const sidebarRef = (0, react_1.useRef)(null);
    const toggleSidebar = () => {
        dispatch((0, appSlice_1.setSidebarOpen)(!sidebarOpen));
    };
    const onMenuClick = (0, react_1.useCallback)(() => {
        dispatch((0, appSlice_1.setSidebarOpen)(false));
    }, [dispatch]);
    const menuItems = (0, react_1.useMemo)(() => _(pages)
        .filter((page) => !!page.menuTitle && !page.excludedFromNavigation)
        .map((page) => ((0, jsx_runtime_1.jsx)("li", { className: ` ${page.divider ? 'divider' : ''}`, children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.NavLink, { onClick: () => onMenuClick(), to: page.url, target: ['http', 'https'].some((protocol) => page.url.startsWith(protocol))
                ? '_blank'
                : '_self', children: [(0, jsx_runtime_1.jsx)("i", { className: `icon icon-geblod_ikon_${page.icon}` }), page.menuTitle, page.menuTitle === 'Kontakta oss' && ((0, jsx_runtime_1.jsx)("i", { className: "icon small-icon icon-geblod_ikon_external" }))] }) }, page.url)))
        .value(), [onMenuClick, pages]);
    const clearSessionLogin = () => {
        sessionStorage.setItem('login', 'false');
    };
    // Trap focus inside the sidebar
    (0, react_1.useEffect)(() => {
        if (!sidebarOpen)
            return;
        const sidebar = sidebarRef.current;
        const focusableElements = sidebar === null || sidebar === void 0 ? void 0 : sidebar.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
        if (!focusableElements || focusableElements.length === 0)
            return;
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];
        const handleTabKey = (e) => {
            if (e.key !== 'Tab')
                return;
            if (e.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstFocusableElement) {
                    e.preventDefault();
                    lastFocusableElement.focus();
                }
            }
            else {
                // Tab
                if (document.activeElement === lastFocusableElement) {
                    e.preventDefault();
                    firstFocusableElement.focus();
                }
            }
        };
        document.addEventListener('keydown', handleTabKey);
        return () => {
            document.removeEventListener('keydown', handleTabKey);
        };
    }, [sidebarOpen]);
    // Prevent body scrolling when the sidebar is open
    (0, react_1.useEffect)(() => {
        if (sidebarOpen) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [sidebarOpen]);
    (0, react_1.useEffect)(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
            if (window.innerWidth >= 992) {
                dispatch((0, appSlice_1.setSidebarOpen)(false));
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [dispatch]);
    return ((0, jsx_runtime_1.jsxs)("div", { ref: sidebarRef, id: "sidebar", className: (0, classnames_1.default)('sidebar', { open: sidebarOpen }), children: [(0, jsx_runtime_1.jsxs)("a", { href: "#main", className: "skip-link", style: { display: sidebarOpen ? 'none' : 'block' }, children: ['', __.trans('aria.skip-link-main'), ''] }), (0, jsx_runtime_1.jsx)("div", { className: "sidebar__container", style: { display: isMobile ? (sidebarOpen ? 'block' : 'none') : 'block' }, children: (0, jsx_runtime_1.jsxs)("div", { className: "sidebar__inner", children: [(0, jsx_runtime_1.jsxs)("div", { className: "upper", children: [(0, jsx_runtime_1.jsx)(MyShortInfo_1.default, {}), (0, jsx_runtime_1.jsx)("nav", { className: "menu", id: "menu", children: (0, jsx_runtime_1.jsxs)("ul", { role: "menu", children: [menuItems, (0, jsx_runtime_1.jsx)("li", { className: ` ${dividerAboveLogOutInMeny ? 'divider' : ''}`, role: "menuitem", children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.NavLink, { tabIndex: 0, to: "/auth/logout", onClick: clearSessionLogin, children: [(0, jsx_runtime_1.jsx)("i", { className: "icon icon-geblod_ikon_loggaut" }), ' ', __.trans('sidebar.logout-title')] }) })] }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "lower", children: [showWebsiteLinkInSidebar && ((0, jsx_runtime_1.jsx)("div", { className: "go-home", children: (0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)("i", { className: "icon icon-geblod_ikon_pil" }), (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)("a", { href: "https://geblod.nu", tabIndex: 0, children: __.trans('sidebar.go-to-geblod') }) })] }) })), (0, jsx_runtime_1.jsx)(Logo_1.default, {}), region && ((0, jsx_runtime_1.jsx)("div", { className: "sidebar__region", children: (0, jsx_runtime_1.jsxs)("span", { children: [__.trans('sidebar.region'), " ", region] }) })), (0, translations_1.keyHasTranslation)('sidebar.footer-text-html') && ((0, jsx_runtime_1.jsx)("footer", { dangerouslySetInnerHTML: { __html: __.trans('sidebar.footer-text-html') } }))] })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "sidebar__overlay", onClick: toggleSidebar, onKeyDown: (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        toggleSidebar();
                    }
                }, role: "button", tabIndex: 0, "aria-label": "Close sidebar" })] }));
};
exports.default = Sidebar;
